import React, { memo } from 'react';
import { lowercaseSoftMutations } from './softMutations';
import { mutationTypes } from './mutationUtils';
import ExplanationMutation from './ExplanationMutation';
import BtnSongMaligorn from './BtnSongMaligorn';
import BtnSongYannGorrig from './BtnSongYannGorrig';
import ListSubTitle from './ListSubTitle';
import ListParagraph from './ListParagraph';

const ExplanationSoftMutation = () => {
  return (
    <ExplanationMutation lowercaseMutations={lowercaseSoftMutations} mutationType={mutationTypes.SOFT}>
      <ul>
        <li>
          <ListSubTitle>les prépositions <em>da</em>, <em>dre</em>, <em>a</em></ListSubTitle>
          <ul>
            <li>
              <ListParagraph>
                Da bet eur emañ...?<br />
                - Da ziv eur emañ.<br />
                - Da deir eur emañ.<br />
                - Da beder eur emañ.<br />
                - Da bemp eur emañ.<br />
                - Da zek eur emañ.<br />
                - Da greisteiz emañ.<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Ezhomm em boa da gousket un tamm. (J'avais besoin de dormir un peu)<br />
                Ezhomm 'm eus mont da gavout ur mezeg. (J'ai besoin de voir un médecin.)<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Paouez da... (= cesser de...)<br />
                Paouezit d'ober trouz! Ne baouezont ket da gomz.
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Lakaat da + infinitif (faire faire)<br />
                Laka an dour da dommañ. N'eo ket aes lakaat anezhañ da gompren.
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Me da gar.<br />
                Ma a gar ac'hanout.<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Kement (autant), muioc'h (plus), nebeutoc'h (moins) + a<br />
                Ober a rit kement a drouz ha ni!<br />
                Anavezout a rit muioc'h a ganaouennoù egedomp.<br />
                Gwelet hon eus nebeutoc'h a dud hiziv eget dec'h.<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Dre belec'h? Da belec'h? Eus pelec'h?<br />
                Dre Vrest emaon o vont.<br />
                Tremen a reont dre Vrest.<br />
                Da Gemper emaon o vont.<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Abalamour da betra 'ta? (À cause de quoi?)<br />
              </ListParagraph>
            </li>
          </ul>
        </li>
        <li>
          <ListSubTitle>les possessifs <em>da</em>, <em>e</em></ListSubTitle>
          <ul>
            <li>
              <ListParagraph>
                Em zi eo chomet da sac'h.<br />
                <BtnSongYannGorrig />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Pelec'h emañ da vreur?<br />
                Piv eo e vamm?<br />
                Da biv eo? Da Gatell?<br />
                Daou gi ha tri c'hazh zo en e di.<br />
              </ListParagraph>
            </li>
          </ul>

        </li>
        <li>
          <ListSubTitle>les particules verbales <em>a</em>, <em>ne</em>, <em>na</em></ListSubTitle>
          <ul>
            <li>
              <ListParagraph>
                - Petra a zebrez?<br />
                - Bara a zebran.<br />
                - Piv a zebr bara?<br />
                - Me a zebr bara.<br />
                Un abadennig volley a vefe mat dit? (Ça te dirait un petit volley?)<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Ne blij ket ar skol din, tamm ebet.<br />
                Ne blij ket an dra-se din tamm ebet.<br />
                Ne zeuont ket bemdez.<br />
                Ne zebran ket ken.<br />
                Ne vez ket lavaret se.<br />
                Ne vern. (peu importe)<br />
                Ne gomzin ket.<br />
                Ne gavan ket mat. (Je n'aime pas.)<br />
                Ne bado ket. (Ça ne va pas durer.)<br />
              </ListParagraph>
            </li>
            <li>
              <ListParagraph>
                Na droit ket a-zehou. (Ne tournez pas à droite.)<br />
                Na zebr ket ar bleunioù!<br />
                Na vez ket trist.<br />
                Na vountit ket war an nor.<br />
                Na brenit ket se.<br />
              </ListParagraph>
            </li>
          </ul>
        </li>
        <li>
          <ListSubTitle>l'adverbe <em>re</em></ListSubTitle>
          <ListParagraph>
            Re vras out!<br />
            Re gozh oc'h!<br />
            Pelec'h emañ ar re vihan?<br />
            Ar re vihan hag ar re vras.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>les numéraux <em>daou</em>, <em>div</em></ListSubTitle>
          <ListParagraph>
            Daou baotr ha div blac'h.
            <BtnSongMaligorn />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>la conjonction de subordination <em>pa</em></ListSubTitle>
          <ListParagraph>
            Chom a ran er gêr pa vez fall an amzer.<br />
            Pa ne vez ket fall ez an da bourmen.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>an holl</ListSubTitle>
          <ListParagraph>
            an holl dud<br />
            an holl verc'hed<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>en em</ListSubTitle>
          <ListParagraph>
            En em gavet e oant dirak an ti-kêr.<br />
            En em welout a reont alies.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle>en ur</ListSubTitle>
          <ListParagraph>
            Lenn a ra en ur vutuniñ.<br />
            Labourat a reont en ur ganañ.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>unan</em> et <em>hini</em> au feminin seulement, <em>homañ</em>, <em>honnezh</em>.</ListSubTitle>
          <ListParagraph>
            Unan kozh pe unan gozh zo war an hent.<br />
            An hini bihan (ur paotr), an hini vras (ur plac'h).<br />
            homañ wenn.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>war/dindan</em></ListSubTitle>
          <ListParagraph>
            war-droad, war varc'h, war varc'h-houarn, war vor.<br />
            mont war droad (aller à pied)<br />
            war zigarez... (sous prétexte...)<br />
            War beseurt studioù emaoc'h?<br />
            War be studi emaout bremañ?<br />
            War beseurt micher emañ ho tud?<br />
            N'a ket an amzer war wellaat. (Le temps ne va pas en s'améliorant.)<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>gwall</em></ListSubTitle>
          <ListParagraph>
            Chistr da dad n'eo ket gwall vat.<br />
            Gwall gozh eo e garr.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>pe</em></ListSubTitle>
          <ListParagraph>
            ur wezh pe ziv.<br />
            en deus daou pe dri.<br />
            Sot-nay out pe betra?<br />
            Te pe gafe ho po?<br />
            Mod pe vod.<br />
            pe dost.<br />
            Pe di?<br />
            Du-mañ pe du-se?<br />
            E tu pe du.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>ra</em></ListSubTitle>
          <ListParagraph>
            Ra gouronki brav! (Que tu nages bien!)<br />
            Ra dec'hint ar buanañ ar gwellañ! (Qu'ils fuient le plus vite possible!)<br />
            Ra vo brav an amzer! (Qu'il fasse beau!)<br />
            Ra zeuint! (Qu'ils viennent!)<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>seul</em></ListSubTitle>
          <ListParagraph>
            Seul vui, seul c'hoazh. (Plus on en a, plus on en veut.)<br />
            Seul gentoc'h, seul welloc'h. (Le plus tôt sera le mieux.)<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>eme</em></ListSubTitle>
          <ListParagraph>
            "..." eme Bêr.<br />
          </ListParagraph>
        </li>
        <li>
          <ListSubTitle><em>ad-</em> mute <em>g, b, m</em> seulement.</ListSubTitle>
          <ListParagraph>
            adwelout<br />
            adveskañ<br />
            adkregiñ<br />
          </ListParagraph>
        </li>
      </ul>
    </ExplanationMutation>
  );
};

export default memo(ExplanationSoftMutation);
